"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeWeightedAverageReceivables = exports.getReceivableWeighting = void 0;
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const getValue_1 = require("../getValue");
const utils_1 = require("../selectFunctions/utils");
const getReceivableWeighting = ({ weighting, receivable, }) => {
    switch (weighting) {
        case 'constant':
            return 1;
        case 'eligibleExposureLessConcentrationKickout':
            return receivable.concentrationLimitFields
                .eligibleExposureLessConcentrationLimitKickouts;
        default:
            return (0, common_1.finleyAssertUnreachable)(weighting);
    }
};
exports.getReceivableWeighting = getReceivableWeighting;
const makeWeightedAverageReceivables = ({ concentrationReceivables, field, weighting, }) => {
    const [concentrationLimitPropertyGroup, concentrationLimitProperty,] = field.split('.');
    (0, common_1.finleyAssert)((0, utils_1.isKeyOfConcentrationLimitFields)(concentrationLimitPropertyGroup), `Invalid concentrationLimitPropertyGroup= ${concentrationLimitPropertyGroup}`);
    return (0, remeda_1.map)(concentrationReceivables, (receivable) => {
        const { finleyReceivableId, concentrationLimitFields: { eligibleExposureLessConcentrationLimitKickouts, }, } = receivable;
        return {
            finleyReceivableId,
            value: (0, getValue_1.getNumberValue)({
                fields: receivable,
                concentrationLimitProperty,
                concentrationLimitPropertyGroup,
            }),
            weight: (0, exports.getReceivableWeighting)({ weighting, receivable }),
            eligibleExposureLessConcentrationLimitKickouts,
        };
    });
};
exports.makeWeightedAverageReceivables = makeWeightedAverageReceivables;
//# sourceMappingURL=WeightedAverageReceivable.js.map